import { Action, Core } from "@faire/slate/foundation/color";
import { Pill } from "@faire/web/slate-deprecated/Filter/styled";
import { getSpacing } from "@faire/web/slate/spacing";
import styled, { css } from "styled-components";

export const ToggleFiltersPill = styled(Pill)<{
  $showAppliedState: boolean;
}>`
  padding: ${getSpacing(0, 10)};

  ${({ $showAppliedState }) =>
    $showAppliedState
      ? css`
          color: ${Core.text.primaryInverse};
          background-color: ${Core.surface.primaryInverse};
        `
      : css`
          border: 1px solid ${Core.border.muted};
          background-color: ${Core.surface.primary};
        `};

  &:hover {
    background-color: ${({ $showAppliedState }) =>
      $showAppliedState ? Core.surface.primaryInverse : Core.surface.primary};
    border-color: ${Action.border.default};
  }
`;
